import StackKit from "@/shared/components/kit/stack";
import HeaderWallet from "./headerwallet";
import ContentLoan from "./content";
import { useQuery } from "@tanstack/react-query";
import { fetchWalletBalance } from "@/api/user/home";
/**
 * WalletReportsComponent
 *
 * کامپوننت اصلی گزارش کیف پول که شامل هدر و محتوای گزارش است.
 *
 * ویژگی‌ها:
 * - واکشی موجودی کیف پول با استفاده از useQuery
 * - نمایش HeaderWallet و ContentWallet با داده‌های واکشی شده
 *
 * @returns JSX.Element
 */
// Task Response:

// کامپوننت به درستی طراحی شده و داده‌ها را با useQuery واکشی می‌کند.
// پیشنهادات بهبود:
// 1. اضافه کردن handling برای isLoading و isError:
//    if (isLoadingBalance) return <div>در حال بارگذاری...</div>;
//    if (isErrBalance) return <div>خطا در بارگذاری موجودی</div>;
// 2. می‌توان gap در StackKit را responsive کرد یا از padding برای فضای داخلی استفاده نمود.
// 3. در صورت بزرگ‌تر شدن گزارش‌ها، اضافه کردن Scroll یا محدود کردن ارتفاع ContentWallet مفید است.

const WalletReportsComponent = () => {
  const {data: dataBalance,isLoading: isLoadingBalance,isError: isErrBalance,} = useQuery({
    queryKey: ["validation-wallet-balance"],
    queryFn: fetchWalletBalance,
  });

  return (
    <StackKit paddingBottom={5} gap={4}>
      <HeaderWallet dataBalance={dataBalance} />
      <ContentLoan dataBalance={dataBalance} />
    </StackKit>
  );
};

export default WalletReportsComponent;
